import { types } from "../type";

const initialState = {
  dprs: [],
  dprDate: "",
  dprError: "",
  dprStatus: "",
  dprDetails: {},
  dprResponse: "",
  dprLocation: "",
  dprLoading: false
};

const dprReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.DprFormTypes.DPR_SET_LOADING:
      return {
        ...state,
        dprLoading: payload
      };
    case types.DprFormTypes.DPR_SET_CREATE_LOADING:
      return {
        ...state,
        dprLoading: payload
      };
    case types.DprFormTypes.DPR_ERRORS:
      return {
        ...state,
        dprLoading: false,
        dprError: payload.data.message,
        dprStatus: payload.status
      };

    case types.DprFormTypes.DPR_CLEAR_RESULT:
      return {
        ...state,
        dprResponse: ""
      };
    case types.DprFormTypes.DPR_CLEAR_ERRORS:
      return {
        ...state,
        dprError: ""
      };
    case types.DprFormTypes.ADD_DPR:
      return {
        ...state,
        dprLoading: false,
        dprResponse: payload.message
      };
    case types.DprFormTypes.GET_ALL_DPR:
      return {
        ...state,
        dprLoading: false,
        dprs: payload.allDprs
      };
    case types.DprFormTypes.ALL_DPR_INPUTS:
      return {
        ...state,
        dprDate: payload.dprDate,
        dprLocation: payload.dprLocation
      };
    case types.DprFormTypes.GET_DPR_DETAILS:
      return {
        ...state,
        dprDetails: payload.dprDetails
      };
    default:
      return state;
  }
};

export default dprReducer;
